import type { PaperSession, PaperSessionStatus } from "../types"

export const PAPER_STATUS_LABEL: Record<PaperSessionStatus, string> = {
  preparing: "Generating",
  not_started: "Not Started",
  in_progress: "In Progress",
  submitted: "Submitted",
  marked: "Marked",
  abandoned: "Abandoned",
  failed: "Failed",
}

export const progressOf = (session: PaperSession) => {
  const answered = session.questions.filter((q) => q.status !== "unanswered").length
  const total = session.questions.length
  return {
    answered,
    total,
    pct: total > 0 ? Math.round((answered / total) * 100) : 0,
  }
}

export const scoreOf = (session: PaperSession) => {
  const scored = session.questions.filter((q) => q.score !== null)
  const score = scored.reduce((acc, q) => acc + (q.score ?? 0), 0)
  const max = session.questions.reduce((acc, q) => acc + q.maxScore, 0)
  return {
    score,
    max,
    pct: max > 0 && scored.length > 0 ? Math.round((score / max) * 100) : 0,
    isPending: session.status === "submitted" && scored.length === 0,
  }
}

export const awaitingMarks = (session: PaperSession) =>
  scoreOf(session).isPending && session.assessmentStatus !== "failed"

const stemText = (html: string) =>
  (html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim()

export const generationProgressOf = (session: PaperSession) => {
  const total = session.requestedCount || session.questions.length
  const filled = session.questions.filter(
    (q) => stemText(q.questionText).length > 0
  ).length
  return {
    filled,
    total,
    pct: total > 0 ? Math.round((filled / total) * 100) : 0,
  }
}
